import { BaseFileModel, FileType } from "./BaseFileModel";

export class DocumentModel extends BaseFileModel {
    Description: string;

    DocumentType: string;
    DocumentTypeID: number;

    MimeType: string;

    Source: number;
    SourceType: number;

    WopiViewable: boolean;
    WopiEditable: boolean;

    msAppIcon: string;
    msFileIcon: string;
    File: any;

    DataSize: number;

    IsSelected?: boolean;

    FolderID: number;

    constructor() {
        super();
        this.FileType = FileType.Document;
    }
}
